// src/http/stepUpResponseHandler.ts
function isRecord(value) {
  return typeof value === "object" && value !== null;
}
function getStepUpConfig(error) {
  if (!isRecord(error)) {
    return void 0;
  }
  const config = error["config"];
  const response = error["response"];
  if (!isRecord(config) || !isRecord(config["headers"]) || config["_stepUpRetried"] === true || !isRecord(response) || response["status"] !== 428) {
    return void 0;
  }
  const data = response["data"];
  if (!isRecord(data) || !isRecord(data["error"]) || data["error"]["code"] !== "STEP_UP_REQUIRED") {
    return void 0;
  }
  return config;
}
function deleteAuthorizationHeader(headers) {
  if (!isRecord(headers)) {
    return;
  }
  const deleteHeader = headers["delete"];
  if (typeof deleteHeader === "function") {
    deleteHeader.call(headers, "Authorization");
    return;
  }
  for (const name of Object.keys(headers)) {
    if (name.toLowerCase() === "authorization") {
      Reflect.deleteProperty(headers, name);
    }
  }
}
function createStepUpResponseErrorHandler(options) {
  return async (error) => {
    const config = getStepUpConfig(error);
    if (!config) {
      return options.onUnhandled(error);
    }
    try {
      await options.requestStepUp();
    } catch {
      throw error;
    }
    config._stepUpRetried = true;
    deleteAuthorizationHeader(config.headers);
    return options.retry(config);
  };
}

export { createStepUpResponseErrorHandler };
//# sourceMappingURL=stepUpResponseHandler.js.map
//# sourceMappingURL=stepUpResponseHandler.js.map